import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class HillsBlastFurnaceBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.HILLS_BLAST_FURNACE;
}

export default HillsBlastFurnaceBuildingTileEntity;
